export enum AccuracyReportsWizardContextSteps {
  SelectProjects = 1,
  SelectActionableProviders = 2,
  Configure = 3,
}

export interface AccuracyProject {
  customProjectId: number;
  name: string;
  isSelected?: boolean;
  isVisible?: boolean;
}

export interface WizardStepProps {
  setPageIsValid?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const reportFormatOptions = ["CSV File", "Pipe-delimited Text", "Tab-delimited Text"] as const;
export type ReportFormatOptionsType = typeof reportFormatOptions[number];

export const frequencyOptions = ["One-Time", "Daily", "Weekly", "Monthly"] as const;
export type FrequencyOptionsType = typeof frequencyOptions[number];

export const combineDateTimeToISO = (dateString: string, timeString: string): string => {
  if (!dateString || !timeString) {
    return "";
  }

  const [year, month, day] = dateString.split('-').map(Number);
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date(year, month - 1, day, hours, minutes);

  return date.toISOString();
};